import * as Sentry from "@sentry/react";
import { CaptureContext } from '@sentry/types';

const errorTypes = {
  GenericUnhandledRejectionError: "generic-undhandled-rejection-error",
  GenericError: "generic-error",
  GenericDidCatchError: "generic-did-catch-error",
  LoginError: "login-error",
} as const;

const errorLocationTagDefault = "default";

type SentryErrorType = typeof errorTypes[keyof typeof errorTypes]

/**
 * Sends an error-log to sentry with a specified type-tag.
 * @param exception exception to send to sentry (e.g. Error or custom Error)
 * @param errorType the type of error
 * @returns sentryEventId (string)
 */
export const captureSentryException = (exception: any, errorType: SentryErrorType, errorLocation?: string): string => {
  const context: CaptureContext = {
    tags: {
      "type": errorType,
      "location": errorLocation ?? errorLocationTagDefault
    }
  };

  return Sentry.captureException(exception, context)
};
